// src/main.ts
/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

import '@progress/kendo-angular-intl/locales/de/all';

import { registerLocales } from './locale-init';
import { appConfig } from './app/app.config';

// Locale einmal registrieren
registerLocales();

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  // console.error(err);
});
